import bootstrap from '../../media/tech-logo/bootstrap.png';
import css from '../../media/tech-logo/css.png';
import figma from '../../media/tech-logo/figma.png';
import github from '../../media/tech-logo/github.png';
import html from '../../media/tech-logo/html.png';
import js from '../../media/tech-logo/javascript.png';
import mentor from '../../media/tech-logo/mentor.png';
import psql from '../../media/tech-logo/psql.png';
import python from '../../media/tech-logo/python.png';
import r from '../../media/tech-logo/r.png';
import rails from '../../media/tech-logo/rails.png';
import react from '../../media/tech-logo/react.png';
import ruby from '../../media/tech-logo/ruby.png';
import redux from '../../media/tech-logo/redux.png';
import sass from '../../media/tech-logo/sass.png';
import vscode from '../../media/tech-logo/vscode.png';
import leader from '../../media/tech-logo/leadership.png';
import collaborator from '../../media/tech-logo/colaborator.png';

export const data = [
  {
    id: 1,
    image: js,
    title: 'JavaScript',
    details: 'JavaScript is a high-level programming language commonly used for web development. It allows you to create dynamic and interactive web pages. It is widely supported by all major browsers and can be used for both front-end and back-end development.',
    features: [
      'Event handling',
      'DOM manipulation',
      'Asynchronous with Promises',
      'Building Single Page Applications',
    ],
  },
  {
    id: 2,
    image: sass,
    title: 'Sass',
    details: 'Sass is a CSS preprocessor that extends the capabilities of CSS with variables, nesting, and other programming constructs. It simplifies the process of styling web pages and allows for easier code organization with mixins, inheritance.',
    features: [
      'Variables',
      'Mixins',
      'Nesting',
      'Support for functions',
    ],
  },
  {
    id: 3,
    image: ruby,
    title: 'Ruby',
    details: 'Ruby is a dynamic, object-oriented programming language known for its simplicity and productivity. It is often used for web development, Ruby is great for building desktop applications, static websites, data processing services, and even automation tools.',
    features: [
      'Easy-to-read syntax',
      'Object-oriented design',
      'Extensive libraries (gems)',
      'Strong community support',
    ],
  },
  {
    id: 4,
    image: rails,
    title: 'Ruby on Rails',
    details: 'Ruby on Rails (often called Rails) is a popular web application framework built on Ruby. It follows the Model-View-Controller (MVC) pattern and emphasizes convention over configuration, making it quick to develop web applications.',
    features: [
      'MVC architecture',
      'Automatic code generation',
      'RESTful routing',
      'Large ecosystem of gems',
    ],
  },
  {
    id: 5,
    image: react,
    title: 'React',
    details: 'React is a JavaScript library used for building user interfaces and User Interface(UI) components. It is maintained by Facebook and provides a declarative approach to creating interactive User Interfaces with the help of Virtual DOM for efficient Rendering.',
    features: [
      'Component-based architecture',
      'Virtual DOM efficient rendering',
      'One-way data flow',
      'various libraries and tools',
    ],
  },
  {
    id: 6,
    image: redux,
    title: 'Redux',
    details: 'Redux is a predictable state management library for JavaScript applications, especially those built with React. It helps manage application state in a centralized store and facilitates predictable updates along with Time Travel Debugging.',
    features: [
      'Centralized state management',
      'State manipulation',
      'Time-travel debugging',
      'Enhance React',
    ],
  },
];

export const techLogos = [
  {
    id: 1,
    image: html,
    title: 'HTML',
  },
  {
    id: 2,
    image: css,
    title: 'CSS',
  },
  {
    id: 3,
    image: sass,
    title: 'SASS',
  },
  {
    id: 4,
    image: js,
    title: 'JavaScript',
  },
  {
    id: 5,
    image: react,
    title: 'React',
  },
  {
    id: 6,
    image: redux,
    title: 'Redux',
  },
  {
    id: 7,
    image: bootstrap,
    title: 'Bootstrap',
  },
  {
    id: 8,
    image: ruby,
    title: 'Ruby',
  },
  {
    id: 9,
    image: rails,
    title: 'Rails',
  },
  {
    id: 10,
    image: psql,
    title: 'PostgreSQL',
  },
  {
    id: 11,
    image: python,
    title: 'Python',
  },
  {
    id: 12,
    image: r,
    title: 'R-Software',
  },
  {
    id: 13,
    image: github,
    title: 'GitHub',
  },
  {
    id: 14,
    image: figma,
    title: 'Figma',
  },
  {
    id: 15,
    image: mentor,
    title: 'Mentor',
  },
  {
    id: 17,
    image: leader,
    title: 'Leadership',
  },
  {
    id: 18,
    image: collaborator,
    title: 'Collaborator',
  },
  {
    id: 19,
    image: vscode,
    title: 'Vs-Code',
  },
];
